import Link from "next/link";
import { useRouter } from "next/router";

import React from "react";

import { twMerge } from "tailwind-merge";

import { faShareAlt } from "@fortawesome/free-solid-svg-icons/faShareAlt";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import useNotification from "components/Notification/useNotification";
import { emberAppBaseUrl } from "utils/envVariables";

export type BreadcrumbItem = {
  title: React.ReactNode;
  icon?: React.ReactNode;
  href?: string;
};

const Breadcrumb = ({
  items,
  shareable,
  containerClassName,
  customRightElements,
}: {
  items: BreadcrumbItem[];
  shareable?: boolean;
  containerClassName?: string;
  customRightElements?: React.ReactNode;
}) => {
  const router = useRouter();
  const { setNotification } = useNotification();

  return (
    <div
      className={twMerge(
        "flex",
        "pb-[10px]",
        "border-0 border-b border-solid border-black/10",
        "w-full",
        containerClassName
      )}
    >
      <div className="flex-1 flex">
        {items.map(({ title, icon, href }, index) => {
          const lastItem = index === items.length - 1;

          const content = (
            <>
              {icon && <div className="mr-[5px]">{icon}</div>}
              <div>{title}</div>
            </>
          );

          return (
            <React.Fragment key={href}>
              {lastItem ? (
                <>
                  <div
                    className={twMerge(
                      "flex",
                      "max-w-[300px] max-h-[25px] overflow-hidden line-clamp-1"
                    )}
                  >
                    {content}
                  </div>
                  {shareable && (
                    <a
                      className="ml-[1em] pl-[0.9em] border-0 border-l border-solid border-black/20"
                      href={`${emberAppBaseUrl}${router.asPath}`}
                      onClick={(e) => {
                        e.preventDefault();
                        navigator.clipboard.writeText(
                          `${emberAppBaseUrl}${router.asPath}`
                        );
                        setNotification(
                          "Copied to clipboard successfully.",
                          "success"
                        );
                      }}
                    >
                      <FontAwesomeIcon icon={faShareAlt} className="mr-[5px]" />
                      Share
                    </a>
                  )}
                </>
              ) : (
                <Link
                  href={href || ""}
                  className={twMerge(
                    "flex",
                    "text-intelligent-silver",
                    "max-w-[300px] max-h-[25px] overflow-hidden line-clamp-1"
                  )}
                >
                  {content}
                </Link>
              )}
              {!lastItem && (
                <div className="mx-[0.5em] text-intelligent-silver">〉</div>
              )}
            </React.Fragment>
          );
        })}
      </div>
      <div>{customRightElements}</div>
    </div>
  );
};

export default Breadcrumb;
